import { render, staticRenderFns } from "./NewLibraryTermDialog.vue?vue&type=template&id=2cd6e017&scoped=true&"
import script from "./NewLibraryTermDialog.vue?vue&type=script&lang=ts&"
export * from "./NewLibraryTermDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewLibraryTermDialog.vue?vue&type=style&index=0&id=2cd6e017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6e017",
  null
  
)

export default component.exports